/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SyncDefs from './defs.defs.js'

const $nsid = 'com.atproto.sync.listHosts'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 1000 }),
      200,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  hosts: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Host>((() => host) as any)),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates upstream hosts (eg, PDS or relay instances) that this service consumes from. Implemented by relays. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type Host = {
  $type?: 'com.atproto.sync.listHosts#host'

  /**
   * hostname of server; not a URL (no scheme)
   */
  hostname: string

  /**
   * Recent repo stream event sequence number. May be delayed from actual stream processing (eg, persisted cursor not in-memory cursor).
   */
  seq?: number
  accountCount?: number
  status?: SyncDefs.HostStatus
}

export type { Host }

const host = /*#__PURE__*/ l.typedObject<Host>(
  $nsid,
  'host',
  /*#__PURE__*/ l.object({
    hostname: /*#__PURE__*/ l.string(),
    seq: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    accountCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SyncDefs.HostStatus>(
        (() => SyncDefs.hostStatus) as any,
      ),
    ),
  }),
)

export { host }
